import React, { useState, useContext } from 'react'
import { SessionContext } from 'data/context'
import { Container, Wrapper } from './Styled'
import { DashboardLayout } from 'core/components/DashboardLayout'
import { Header } from './Header'
import { Table } from './Table'
import { useQuery } from '@apollo/client'
import { api } from 'data/apollo/api'
import { LogoAnim } from 'core/components/LogoAnim'
import { ErrorScreen } from 'core/components/ErrorScreen'
import { Form } from './Form'

export const Permanent: React.FC<{dealers: [any]}> = ({dealers}) => {
  const [showForm, setShowForm] = useState(false)
  const [formData, setFormData] = useState<any>(null)
  const { loading, error, data } = useQuery(api.remote.query.permanentStock);
  const { readOnly } = useContext(SessionContext)
  
  if (loading) {
    return <LogoAnim />
  }
  
  if (error) {
    return <ErrorScreen />
  }
  
  return (
    <Container>
      {showForm && !readOnly && (
        <Form dealers={dealers} setShowForm={setShowForm} form={{ formData, setFormData }} />
      )}
      <DashboardLayout />
      <Wrapper>
        <Header setShowForm={setShowForm} />
        <Table data={data.permanentStock} dealers={dealers} form={{ setShowForm, setFormData }} />
      </Wrapper>
    </Container>
  )
}
